import { render, staticRenderFns } from "./Metaphors.vue?vue&type=template&id=c6e8bbb2&scoped=true"
import script from "./Metaphors.vue?vue&type=script&lang=js"
export * from "./Metaphors.vue?vue&type=script&lang=js"
import style0 from "./Metaphors.vue?vue&type=style&index=0&id=c6e8bbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8bbb2",
  null
  
)

export default component.exports